import { inject, provideAppInitializer, EnvironmentProviders } from '@angular/core';
import { RestauracionSesionService } from '@core/services/restauracion-sesion/restauracion-sesion.service';

export interface OpcionesRestauracionSesion {
  restauracionSesionService: RestauracionSesionService;
}

export function activarRestauracionSesionAlArrancar(opciones: OpcionesRestauracionSesion): void {
  opciones.restauracionSesionService.activar();
}

export function proveedorRestauracionSesion(): EnvironmentProviders {
  return provideAppInitializer(() => {
    activarRestauracionSesionAlArrancar({
      restauracionSesionService: inject(RestauracionSesionService),
    });
  });
}
